import React, { useRef, useState } from 'react';
import * as api from 'lib/api';
import Modal from 'components/Modal';
import Button from 'components/Button';
import './timesheet-decision.scss';

export default function TimesheetArchiveModal({ timesheetKey, onClose, onSuccess, unarchive = false }) {
  const action = unarchive ? 'unarchive' : 'archive';
  const title = unarchive ? 'Unarchive Timesheet' : 'Archive Timesheet';
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const close = () => { if (!pending.current) onClose(); };
  const archive = async () => {
    if (pending.current) return;
    pending.current = true;
    setSaving(true);
    setError('');
    try {
      const response = await api.post(`timesheets/${action}`, { timesheetKey });
      if (response?.status !== 200 || response.body?.success !== true) throw new Error('Archive failed');
    } catch (err) {
      pending.current = false;
      setSaving(false);
      setError(`Unable to ${action} this timesheet. Please try again.`);
      return;
    }
    onSuccess();
  };

  return (
    <Modal isOpen header={title} contentLabel={`${unarchive ? 'Unarchive' : 'Archive'} timesheet`} onRequestClose={close} contentStyle={{ width: 560, maxWidth: 'calc(100vw - 32px)' }} bodyStyle={{ overflowY: 'auto' }}>
      <div className="timesheet-decision">
        <p>{unarchive ? 'Are you sure you want to unarchive this timesheet? It will be visible in the main list again.' : 'Are you sure you want to archive this locked timesheet? It will be hidden from the main list. You can find it by turning on “Show archived timesheets”.'}</p>
        {error && <p role="alert" className="timesheet-decision__error">{error}</p>}
        <div className="timesheet-decision__actions">
          <Button white className="timesheet-decision__cancel" disabled={saving} onClick={close}>Cancel</Button>
          <Button loading={saving} loadingContent={unarchive ? 'Unarchiving…' : 'Archiving…'} onClick={archive}>{title}</Button>
        </div>
      </div>
    </Modal>
  );
}
